import React from 'react'
import { DataTable } from 'primereact/datatable'
import { enums } from '../../../constants'
import utils from '../../../utils/index'
import { Card } from 'primereact/card'
import { TabPanel, TabView } from 'primereact/tabview'
import _ from 'lodash'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { InputTextarea } from 'primereact/inputtextarea'
import {
  emProcessamento,
  itemSelecionavel,
  labelConsultaRemessa,
  mostrarCheckbox,
  linhasContagem,
  nomeStatusItem,
  textoStatusRemessa,
} from '../consultaRemessa.utils'

export const ConsultaRemessaForm = (props) => {
  const record = props.record
  const messages = props.messages
  let identificacao = record.identificacao
  const logs = _.get(record, 'logs', [])
  const label = (chave, ...parametros) => labelConsultaRemessa(messages, chave, ...parametros)

  // PHOENIX-977: resumo da remessa - situacao e itens por status. As contagens sao da remessa inteira; a grade
  // abaixo mostra so a pagina pedida ao back. Os erros da geracao de lancamentos sao itens da grade (sem
  // lancamento), como no sincrono; aqui so a mensagem da propria remessa (emissao que fechou sem emitir).
  function getResumo() {
    const linhas = linhasContagem(record, (codigo) => nomeStatusItem(messages, codigo))
    return (
      <div className="p-grid p-fluid" style={{ marginBottom: '10px' }}>
        <div className="p-col-12 p-md-4">
          <strong>{label('situacao')}: </strong>
          {textoStatusRemessa(messages, record.status)}
          {emProcessamento(record) && (
            <div style={{ color: '#1976d2', marginTop: '5px' }}>
              <span className="pi pi-spin pi-spinner" style={{ marginRight: '5px' }} />
              {label('avisoEmProcessamento')}
            </div>
          )}
          {record.mensagemRemessa && <div style={{ marginTop: '5px' }}>{record.mensagemRemessa}</div>}
        </div>
        <div className="p-col-12 p-md-8">
          <strong>{label('itensPorSituacao')}: </strong>
          {linhas.map((linha) => (
            <span key={linha.codigo} style={{ marginRight: '15px' }}>
              {linha.nome}: {linha.quantidade}
            </span>
          ))}
          <span>
            <strong>{label('total')}: </strong>
            {record.totalItens || 0}
          </span>
        </div>
      </div>
    )
  }

  function getDadosGerais() {
    const pagina = props.pagina || {}
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          {getResumo()}
          <DataTable
            lazy={true}
            dataKey="oid"
            selectionPageOnly={true}
            selection={props.selection}
            onSelectionChange={props.onSelectionChange}
            isDataSelectable={(e) => itemSelecionavel(e.data)}
            showSelectionElement={mostrarCheckbox}
            reorderableColumns={true}
            resizableColumns={true}
            columnResizeMode="expand"
            filterDisplay="row"
            ref={props.dataTableItens}
            paginator={true}
            emptyMessage=" "
            first={pagina.first || 0}
            rows={pagina.rows || 15}
            sortField={pagina.sortField}
            sortOrder={pagina.sortOrder}
            onPage={props.onPage}
            onSort={props.onSort}
            loading={props.carregandoItens}
            rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
            value={props.itens || []}
            totalRecords={props.totalItens || 0}
          >
            {props.colunasItens}
          </DataTable>
          <br />
          <div style={{ textAlign: 'right', margin: '7px' }}>
            <strong>{label('total')}: </strong> {props.totalItens || 0}
          </div>
        </div>
      </div>
    )
  }
  function getDadosLogs() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <DataTable
            resizableColumns={true}
            columnResizeMode="expand"
            ref={props.dataTableLogs}
            paginator={true}
            emptyMessage="  "
            rows={15}
            rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
            value={logs}
            totalRecords={logs.length}
          >
            {props.colunasLogs}
          </DataTable>
        </div>
      </div>
    )
  }
  function getContent() {
    return (
      <>
        <Accordion>
          <AccordionTab header={utils.getMessage(messages, 'consultaremessa.label.filtros')}>
            <div className="p-grid p-fluid">
              <div className="p-col-12"></div>
              <InputTextarea
                value={record.parametros}
                name="parametros"
                rows={1}
                cols={100}
                autoResize={true}
                style={{ marginBottom: '10px;' }}
              />
            </div>
          </AccordionTab>
        </Accordion>
        <br />
        <TabView activeIndex={props.state.activeIndex} onTabChange={(e) => props.changeActiveIndex(e.index)}>
          <TabPanel header={utils.getMessage(messages, 'consultaremessa.label.dadosgerais')}>
            {getDadosGerais()}
          </TabPanel>
          <TabPanel header={utils.getMessage(messages, 'consultaremessa.label.logs')}>{getDadosLogs()}</TabPanel>
        </TabView>
      </>
    )
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card
          title={`${utils.getMessage(messages, 'consultaremessa.label.consultaRemessas')} ${record.oid || ''}`}
          subTitle={identificacao || ''}
        >
          {getContent()}
        </Card>
      </div>
    </div>
  )
}
